import React, { useState } from 'react';
import { TextField, Button, Typography, Stack } from '@mui/material';
import { useSubscribeToNewsLetter } from '../../hooks';

const EmailSubscriptionForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { error, setError, subscribeToNewsLetter, success } = useSubscribeToNewsLetter();
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async () => {
    setIsLoading(true);
    if (isEmailValid) {
      setError('');
      await subscribeToNewsLetter(email);
      setIsLoading(false);
    }
    if (!isEmailValid) {
      setError('Invalid Email');
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <Stack direction="row" spacing={6} alignItems="flex-start" justifyContent="start" sx={{ mt: 4, pt: 2 }}>
      {success ? (
        <Typography>Thank you for subscribing!</Typography>
      ) : (
        <>
          <TextField
            size="small"
            label="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value.toLocaleLowerCase())}
            error={!!error}
            helperText={error}
          />
          <Button variant="contained" size="medium" loading={isLoading} disabled={!isEmailValid} onClick={handleSubmit}>
            Subscribe
          </Button>
        </>
      )}
    </Stack>
  );
};

export default EmailSubscriptionForm;
